import { inject } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import {
  CONFIGURE_DEFAULT_PARAMS,
  LoadGridPayload,
  PinnedSortBy,
  pinnedSortToSortParam,
} from '@data-access/shared';
import { WcgTableUtilsService } from '@shared/services/wcg-table-utils.service';

import { organizationStudyListTokenizer } from '../store';

export const studyListResolver = (route: ActivatedRouteSnapshot) => {
  const _studySignalStore = organizationStudyListTokenizer();
  const _wcgTableUtils = inject(WcgTableUtilsService);

  const _pinnedSort = route.queryParams['pinnedSort'] as PinnedSortBy | null;
  const _sortParam = pinnedSortToSortParam(_pinnedSort, 'study');
  const _isPinned = route.queryParams['is_pinned'] === 'true';

  const _params = _wcgTableUtils.generateTableQueryParams(
    {
      ...CONFIGURE_DEFAULT_PARAMS(route),
      ...(_sortParam ? { sortParam: _sortParam } : {}),
    },
  );

  const _payload: LoadGridPayload = {
    params: _params,
  };

  const id = route.paramMap.get('id') ?? route.parent?.data['contactId'] ?? '';
  _studySignalStore.setByURL(route.data.type ?? 'main', id, _isPinned);
  _studySignalStore.loadStudyGrid(_payload);
  _studySignalStore.updateSort(
    _sortParam as { field: string; dir: 'asc' | 'desc' } | null,
  );

  return !!_studySignalStore.$studies();
};
